module.exports = __webpack_public_path__ + "media/virtual.1ec53e80.mp4";